// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","body2":"_3SZbtBhXKsMgrIDYFmK8U","subheader":"_3tfkBLzh4oNF67_ojQV2Pn","name":"_35LMMJVA8YhBfc6e4hnf9m _3tfkBLzh4oNF67_ojQV2Pn","shippingContent":"_1kIvl0RjiSrnyHZJ9kSTMK _2lYHSCAcM6vA2s-47YYZeS","agencyHeader":"WGrbJvdVDKCAy9Fp0Ch3x _3SZbtBhXKsMgrIDYFmK8U","agencyText":"_2Pac3MiFmF5dhUD7UzOTlj"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/shipping/section-content/SectionContent.css
// module id = 1168
// module chunks = 2